import { useEffect } from 'react';
import useStorage from './useStorage';
import { useTypedFastStorage } from './useFastStorage';
import postal from 'postal';

import useTableNavigation from '../ui/tables/useTableNavigation';
import useListHeightMonitor from './useListHeightMonitor';

export default function useListData(name: string, onDoubleClick: any, tableColumnDefaultFocusHierarchy: Array<any>, onCellRightClick: ((row: number, column: number, node: Element, e:MouseEvent) => void) | undefined = undefined, initialized: boolean, setListDataWhenCellClick:any) {
  const channel = postal.channel('ifms-filter');
  useListHeightMonitor(name);

  let currentCount = 0;

  const dataKeySufix = `${window.location.pathname}${window.location.search}`;

  const [data, _setData, removeDataFromStorage, dataRef] = useTypedFastStorage<Array<any>>(`ifms-list-data-${dataKeySufix}`, []);
  const [selectedId, _setSelectedId, removeSelectedIdFromStorage, selectedIdRef] = useStorage(name, null);
  const { selectTableRow, tableNavigationCleanup, triggerTableSearch, getSelectedRow, doSelectTableCellAndNotify } = useTableNavigation(name, onRowSelected, onDoubleClick, tableColumnDefaultFocusHierarchy || [], false, false, false, onDoubleClick, onCellRightClick, initialized);

  useEffect(() => {
    if (data && data.length > 0 && !selectedId) {
      applyIdSelectionAlgorithm(data);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function applyIdSelectionAlgorithm(data:any) {
    if (data && data.length > 0) {

      if (!selectedIdRef.current || !data.some((d:any) => d.id === selectedIdRef.current)) {
        setSelectedId(data[0].id);
      } 
    } else {
      setSelectedId(null);
    }
  }

  function onRowSelected(index:number) {
    if(setListDataWhenCellClick) setListDataWhenCellClick();

    if (dataRef.current && index >= 0 && index < dataRef.current.length) {
      setSelectedId((dataRef.current[index] as any).id);
    }
  }

  function setData(d:any, count:number) {
    // Make sure it is not data merge but complete replace
    //removeDataFromStorage();
    _setData(d);
    applyIdSelectionAlgorithm(d);
    currentCount = count;
    channel.publish('ifms-filter.countsetter', count);
  }

  function setSelectedId(id:any) {
    selectedIdRef.current = id;
    _setSelectedId(id);
  }

  function getSelectedIndex() {
    if (!selectedIdRef || !selectedIdRef.current || !dataRef || !dataRef.current) {
      return -1;
    }

    return dataRef.current.findIndex((x:any) => x.id + '' === selectedIdRef.current + '');
  }


  function clearListData() {
    removeDataFromStorage();
    tableNavigationCleanup();
    removeSelectedIdFromStorage();
  }

  return {
    data: data ?? [],
    dataRef,
    setData,
    setSelectedId,
    getSelectedIndex,
    clearListData,
    selectTableRow,
    triggerTableSearch,
    currentCount,
    getSelectedRow,
    doSelectTableCellAndNotify
  };
}
  